import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// Import images
import operationIconActive from "./images/operationiconactive.webp";
import operationIconInactive from "./images/operationnonactive.webp";
import synergyIconActive from "./images/synergyIconActive.webp";
import synergyIconInactive from "./images/synergyIconInactive.webp";

const TabsComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("operation");

  // Set active tab based on current path
  useEffect(() => {
    const path = location.pathname;

    if (path.includes("business-networking-solutions")) {
      setActiveTab("synergy");
    } else if (path.includes("business-workflow-automation")) {
      setActiveTab("operation");
    }
  }, [location.pathname]);

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  return (
    <div className="d-flex justify-content-center mt-3">
      <div
        className="d-flex shadow overflow-hidden"
        style={{ width: "248px", height: "74px", borderRadius: "23px" }}
      >
        {/* Operation 360 Tab */}
        <button
          className={`btn flex-fill py-2 ${activeTab === "operation" ? "text-white" : "text-dark"}`}
          onClick={() => handleTabClick("operation", "/business-workflow-automation")}
          style={{
            backgroundColor: activeTab === "operation" ? "#AD49E1" : "#FFFFFF",
            border: "none",
            outline: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={activeTab === "operation" ? operationIconActive : operationIconInactive}
            alt="Operation 360"
            width="40.1"
            height="47"
          />
          <span>Operation 360</span>
        </button>

        {/* Synergy 360 Tab */}
        <button
          className={`btn flex-fill py-2 ${activeTab === "synergy" ? "text-white" : "text-dark"}`}
          onClick={() => handleTabClick("synergy", "/business-networking-solutions")}
          style={{
            backgroundColor: activeTab === "synergy" ? "#AD49E1" : "#FFFFFF",
            border: "none",
            outline: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={activeTab === "synergy" ? synergyIconActive : synergyIconInactive}
            alt="Synergy 360"
            width="40.1"
            height="47"
          />
          <span>Synergy 360</span>
        </button>
      </div>
    </div>
  );
};

export default TabsComponent;